export const breakpointsSize = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
}

export const breakpoints = {
  /* Extra small devices (phones, 600px and down) */
  xs: `(max-width: ${breakpointsSize.sm - 1}px)`,

  /* Small devices (portrait tablets and large phones, 960px and down) */
  sm: `(max-width: ${breakpointsSize.md - 1}px)`,

  /* Not mobile */
  mdUp: `(min-width: ${breakpointsSize.md}px)`,

  /* Medium devices (landscape tablets, 1280px and down) */
  md: `(max-width: ${breakpointsSize.lg}px)`,

  /* Large devices (laptops/desktops, 1920px and down) */
  lg: `(max-width: ${breakpointsSize.xl}px)`,

  /* Extra large devices (large laptops and desktops, 1920px and up) */
  xl: `(min-width: ${breakpointsSize.xl}px)`,
}
